import type { ReactNode } from 'react';

import cx from 'classnames';

import styles from './Header.module.scss';

export const Header = (
  { className, children, tall = false }:
  { className?: string; children: ReactNode; tall?: boolean },
) => (
  <div className={cx(styles.header, className, { [styles.tall]: tall })}>
    {children}
  </div>
);
